import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Moment from 'moment'
import axios from 'axios'
import { Card } from 'react-bootstrap'
import { CardBody } from 'reactstrap'
import Sidebar from '../../../components/sidebar/sidebar'
import Navbar from "../../../components/navbar"
import * as CONFIG from "../../../helpers/config"
import { BackButton,} from '../../../components/buttoncomponents'
import { useMsal } from "@azure/msal-react";

function SupplierInvoiceList(props) {
    const { instance } = useMsal();
    const [customerProformaInvoiceData, setPurchaseOrder] = useState()
    const [tradeID, setTradeID] = useState()
    const [tradeData, setTradeData] = useState()
    const [subTotal, setSubTotal] = useState()
    const [totalTax, setTotalTax] = useState()
    const [overAllTotal, setOverAllTotal] = useState()
    const [data, setData] = useState({})
    const [showView, setShowView] = useState(false)

    let navigate = useNavigate();

    useEffect(()=> {
        let listValues = []
        let listValuesTax = []
        const json_list = {
            "instanceID": CONFIG.PMSInstanceID,
            "accountSubscriptionID": CONFIG.AccountSubscriptionID,
            "created_User": CONFIG.LoginID,
            
            
        }
        axios.post(CONFIG.TMS_SERVER_URL + CONFIG.GET_SUPPLIER_INVOICE, json_list, { headers: { "Authorization": `Bearer ${CONFIG.AuthToken}`, "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
            .then((res) => {
               console.log(res.data.result)
               setPurchaseOrder(res.data.result)
            }).catch((error)=>{
                if(error.response.status == 401){
                    localStorage.clear();
                    instance.logoutRedirect({
                      postLogoutRedirectUri: "/",
                    });
                }
            })  
    },[])
    
    const back = () => {
        navigate('/trade-transactions', { state:{ tab: 1,}});
    }
    const handlePurchaseOrder = (e) => {
        console.log(e.target.id)
        console.log(customerProformaInvoiceData)
        const json_list = {
            "instanceID": CONFIG.PMSInstanceID,
            "accountSubscriptionID": CONFIG.AccountSubscriptionID,
            "created_User": CONFIG.LoginID,
            "id":parseInt(e.target.id)
            
        }
        axios.post(CONFIG.TMS_SERVER_URL + CONFIG.GET_TRADE_DETAIL_BY_ID, json_list, { headers: { "Authorization": `Bearer ${CONFIG.AuthToken}`, "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
        .then((res) => {
           console.log(res.data.result)
           setTradeData(res.data.result.filter(x=> x.tradeID == e.target.id)[0])
           console.log(res.data.result.filter(x=> x.tradeID == e.target.id)[0])
        //    navigate('/customer-proforma-invoice', { state:{tradeData: res.data.result.filter(x=> x.tradeID == customerProformaInvoiceData.tradeId)[0], tab: 1, tradeID: customerProformaInvoiceData.tradeID}})
        }).catch((error)=>{
            if(error.response.status == 401){
                localStorage.clear();
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
            }
        })  
    }

    const handleBase64Validation = (values) => {
        let searchData = values.supplierDocument.includes("data:")
        let searchBase64 = values.supplierDocument.includes("base64")
    }
  return (
    <>
     <div className='main-wrapper inner-wrapper d-flex'>
            <Sidebar id='7.5' isOpenid={7} />
            <div className='width-100'>
                <Navbar />
                    <div className='d-flex mt-4' style={{paddingLeft: '37px',}}>
                        <div className = 'd-flex justify-content-center align-items-center '>
                            <BackButton clickEvent={back} />
                        </div>
                    </div>
                <div className='d-flex justify-content-between align-items-center mx-4 px-5 mt-5'>
                    <div className='d-flex align-items-center'>
                        <img src='assets/images/sidebaricons/TradeEnquiry.svg' className='inner-page-titleicon img-fluid' /><span className='font-16 font-weight-600 color-707895 d-flex align-items-center pl-10'>SUPPLIER INVOICES</span>
                    </div>
                </div>
                <div className='inner-page-content mx-md-4 mx-2'>
                    <Card>
                        <CardBody>
                            <div class="col-lg-12 list-scroll">
                                <div class="table-responsive-sm ">
                                    <table className="table tCustom table-text">
                                        <thead className='p-1-rem'>
                                            <tr className='text-uppercase list-top'>
                                                <th>supplier invoice#</th>
                                                <th>invoice date</th>
                                                <th>trade#</th>
                                                <th>supplier</th>
                                                <th>Document</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {customerProformaInvoiceData != null && customerProformaInvoiceData.length > 0 ?
                                            customerProformaInvoiceData.map((values,k) =>(
                                            <tr>
                                            <td className='font-14 font-weight-500'><p className='w-150 mb-0'>{values.supplierInvoiceNo}</p></td>
                                            <td className='font-14 font-weight-500'><p className='w-150  mb-0'>{Moment(values.supplierInvoiceDate).format("DD/MM/YYYY")}</p></td>
                                            <td className='font-14 font-weight-500'><p className='w-150  mb-0'>{values.tradeNo}</p></td>
                                                <td>
                                                    <div className = 'd-flex flex-column w-200'>

                                                        <div>
                                                            {values.supplierName}
                                                        </div>
                                                        <div>
                                                            {values.supplierCode}
                                                        </div>
                                                        
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className = 'font-weight-600 color-243448'> <a download={values.supplierDocumentName} href = {values.supplierDocument}>{values.supplierDocumentName}</a></div>
                                                </td>
                                            </tr>
                                        )) 
                                        :
                                        ''
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>


    </div>
    </>
   
  )
}

export default SupplierInvoiceList